export default __webpack_public_path__ + "static/media/sinisterBg.12d6d84a.png";